import { useLayoutEffect } from 'react';

import { useGetHsptlzFormCcrcInfo } from '../model';

import TabContainer from './TabContainer';
import Title from './Title';

export const MainPage = () => {
  useGetHsptlzFormCcrcInfo();

  useLayoutEffect(() => {
    const viewport = document.querySelector('meta[name=viewport]');
    if (viewport) {
      viewport.setAttribute(
        'content',
        'width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover',
      );
    }
  }, []);

  return (
    <>
      <div className='container-wrap submitted-form'>
        <Title>
          <Title.Main />
          <Title.Sub />
        </Title>
        <TabContainer />
      </div>
    </>
  );
};
